module.exports = __webpack_public_path__ + "static/media/cookiesPolicy.99948e9a.pdf";